// Géolocalisation du navigateur → lieu (pays + ville), comme ZERO SLANG. Les coordonnées ne sont jamais gardées.
import { offlinePlace } from '../core/region.js';
import { reverseGeocode } from './geocoding.js';

export const geolocationSupported = () => typeof navigator !== 'undefined' && 'geolocation' in navigator;

/** { lat, lon } ; rejette si la position est refusée ou indisponible. */
export function getPosition() {
  return new Promise((resolve, reject) => {
    if (!geolocationSupported()) return reject(new Error('unsupported'));
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      reject,
      { timeout: 8000, maximumAge: 10 * 60 * 1000 },
    );
  });
}

/**
 * { countryCode, country, city? }, ou null si le lieu est introuvable. Ne rejette que si la position elle-même est refusée ou
 * indisponible ; le service de géocodage injoignable laisse la place au secours hors ligne (core/region.js#offlinePlace).
 */
export async function locatePlace({ lang = 'en', position = getPosition, geocode = reverseGeocode } = {}) {
  const { lat, lon } = await position();
  try {
    const place = await geocode(lat, lon, { lang });
    if (place) return place;
  } catch {
    /* service injoignable : secours hors ligne ci-dessous */
  }
  return offlinePlace(lat, lon, lang);
}
